<template>
  <section>
    <tramite-form
      :is-add-new-sidebar-active.sync="isAddNewSidebarActive"
      :form-type="formType"
      :data-edit="dataEdit"
      @refetch-data="refetchData"
      @error-data="showError"
    />

    <normativa-form
      :is-toggle-sidebar-normativa.sync="isToggleSidebarNormativa"
      :form-type-normativa="formTypeNormativa"
      :data-edit-normativa="dataEditNormativa"
      :normativa-sel="normativaSel"
      @refetch-data="refetchData"
      @error-data="showError"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="card-transaction"
    >
      <b-card-header>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Mostrando</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="pageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
          />
          <label>registros</label>
        </b-col>

        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="query"
              class="d-inline-block mr-1"
              placeholder="Buscar..."
            />
            <b-button
              variant="primary"
              @click="openForm('new')"
            >
              <span class="text-nowrap">Nuevo</span>
            </b-button>
          </div>
        </b-col>
      </b-card-header>

      <b-card-body>
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="items"
          responsive
          :fields="fields"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No se encontraron registros"
          :busy="isBusy"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">Cargando...</strong>
            </div>
          </template>
          <template #cell(show_details)="row">
            <b-form-checkbox
              v-model="row.detailsShowing"
              plain
              class="vs-checkbox-con"
              @change="row.toggleDetails"
            >
              <span class="vs-checkbox">
                <span class="vs-checkbox--check">
                  <i class="vs-icon feather icon-check" />
                </span>
              </span>
              <span class="vs-label">{{ row.detailsShowing ? 'Hide' : 'Show' }}</span>
            </b-form-checkbox>
          </template>
          <template #cell(tramite)="data">
            <b-media vertical-align="center">
              <span class="font-weight-bold d-block text-nowrap">
                {{ data.item.tramite }}
              </span>
              <small
                class="text-muted d-block "
              >
                {{ data.item.descripcion }}
              </small>
            </b-media>
          </template>
          <template #cell(orden)="data">
            <b-badge
              variant="dark"
            >
              {{ data.item.orden }}
            </b-badge>
          </template>
          <template #row-details="row">
            <b-table
              :items="row.item.normativas"
              :fields="fieldsNormativas"
              striped
              responsive
              caption-top
              show-empty
              empty-text="No se encontraron registros"
            >
              <template #table-caption>
                <span class="text-center text-white font-weight-bolder">TRÁMITE: {{ row.item.tramite }}</span>
              </template>
              <template #head(acciones)>
                <b-button
                  v-b-tooltip.hover.right="`Agregar Normativa`"
                  variant="primary"
                  size="sm"
                  @click="addNormativa('new', row.item)"
                >
                  <feather-icon
                    icon="FilePlusIcon"
                    class="mx-auto"
                  />
                </b-button>
              </template>
              <template #cell(titulo)="normativa">
                <b-media vertical-align="center">
                  <template #aside>
                    <b-avatar
                      size="30"
                      :src="iconPdf"
                      :variant="`light-success`"
                    />
                  </template>
                  <span class="font-weight-bold d-block text-nowrap">
                    {{ normativa.item.titulo }}
                  </span>
                  <small class="text-muted">
                    <a
                      :href="pathDocuments + normativa.item.archivo"
                      target="_blank"
                    >
                      Ver Archivo
                    </a>
                  </small>
                </b-media>
              </template>
              <template #cell(sumisa)="normativa">
                <small class="text-muted">{{ normativa.item.sumisa }}</small>
              </template>
              <template #cell(orden)="normativa">
                <b-badge
                  variant="dark"
                >
                  {{ normativa.item.orden }}
                </b-badge>
              </template>
              <template #cell(acciones)="normativa">
                <b-button
                  v-b-tooltip.hover.top="`Editar Normativa`"
                  variant="light-dark"
                  class="btn-icon"
                  @click="getEditNormativa(row.item, normativa.item)"
                >
                  <feather-icon icon="EditIcon" />
                </b-button>
                <b-button
                  v-b-tooltip.hover.top="`Eliminar Normativa`"
                  variant="light-dark"
                  class="btn-icon"
                  @click="getDeleteNormativa(normativa.item)"
                >
                  <feather-icon icon="TrashIcon" />
                </b-button>
              </template>
            </b-table>
          </template>

          <!-- Column: Actions -->
          <template #cell(acciones)="data">
            <b-button-toolbar justify>
              <b-button-group size="sm">
                <b-button
                  v-b-tooltip.hover.top="'Ver Normativas'"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  :variant="data.item.normativas.length !== 0 ? 'info' : 'secondary'"
                  @click="data.toggleDetails"
                >
                  <feather-icon icon="FileTextIcon" />
                </b-button>
                <b-button
                  v-b-tooltip.hover.top="'Editar'"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="primary"
                  @click="getEdit(data)"
                >
                  <feather-icon icon="EditIcon" />
                </b-button>
                <b-button
                  v-b-tooltip.hover.top="'Eliminar'"
                  variant="danger"
                  class="btn-cart move-cart"
                  @click="getDelete(data)"
                >
                  <feather-icon
                    icon="Trash2Icon"
                    class="mr-50"
                  />
                </b-button>
              </b-button-group>
            </b-button-toolbar>
          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Mostrando {{ from }} a {{ to }} de {{ of }} registros</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="page"
                :total-rows="totalItems"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </section>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput, BButton, BTable, BBadge, BPagination, BSpinner, BMedia, BButtonToolbar, BButtonGroup, VBTooltip, BFormCheckbox, BAvatar,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import vSelect from 'vue-select'
import config from '@/services/config'
import TramiteForm from './TramiteForm.vue'
import NormativaForm from './NormativaForm.vue'

export default {
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  components: {
    TramiteForm,
    NormativaForm,
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BBadge,
    BPagination,
    BSpinner,
    BMedia,
    BButtonToolbar,
    BButtonGroup,

    vSelect,
    BFormCheckbox,
    BAvatar,
  },
  data: () => ({
    iconPdf: require('@/assets/images/erp/docs/pdf.png'),
    ftPublicado: '',
    isAddNewSidebarActive: false,
    isToggleSidebarNormativa: false,
    dataEdit: {},
    dataEditNormativa: {},
    normativaSel: {},
    formTypeNormativa: '',
    formType: '',
    isBusy: false,
    page: 1,
    perPage: 10,
    totalRows: 0,
    totalItems: 0,
    totalPage: 0,
    from: 0,
    to: 0,
    of: 0,
    pageOptions: [10, 20, 50],
    sortBy: null,
    sortDesc: false,
    sortDirection: 'asc',
    query: '',
    items: [],
    fields: [
      { key: 'show_details', thClass: 'd-none', tdClass: 'd-none' },
      { key: 'idTramiteOrientacion', sortable: true, tdClass: 'd-none', thClass: 'd-none' },
      { key: 'tramite', label: 'Tramite', sortable: true },
      { key: 'orden', sortable: true, tdClass: 'text-center', thClass: 'text-center' },
      { key: 'acciones', thClass: 'w100', tdClass: 'w100' },
    ],
    fieldsNormativas: [
      { key: 'idNormativaTramite', sortable: false, thClass: 'd-none', tdClass: 'd-none' },
      { key: 'titulo', label: 'Titulo', sortable: false, tdClass: 'bkwhite' },
      { key: 'sumisa', label: 'Sumilla', sortable: false, tdClass: 'bkwhite' },
      { key: 'orden', label: 'Orden', sortable: false, tdClass: 'bkwhite' },
      { key: 'acciones', tdClass: 'bkwhite' },
    ],
    pathDocuments: `${config.baseURL}${config.contextApi}/api/v1/public/getPDF/ByUrl?url=`,
  }),
  watch: {
    perPage: {
      handler() {
        this.listarRegistros()
      },
    },
    page: {
      handler() {
        this.listarRegistros()
      },
    },
    query: {
      handler() {
        this.listarRegistros()
      },
    },
    ftPublicado: {
      handler() {
        this.listarRegistros()
      },
    },
  },
  mounted() {
    this.listarRegistros()
  },
  methods: {
    addNormativa(type, data) {
      this.normativaSel = data
      this.formTypeNormativa = type
      this.isToggleSidebarNormativa = true
    },
    getDeleteNormativa(data) {
      this.$swal({
        title: 'Está seguro?',
        text: 'Va eliminar un registro!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store
            .dispatch('portal/NORMATIVA_TRAMITE_DELETE', {
              id: data.idNormativaTramite,
            })
            .then(response => {
              this.listarRegistros()
              this.showToast('Operación Extitosa', 'Ha Eliminado correctamente el registro.', 'success')
              return response
            })
            .catch(error => {
              this.showToast('Ha ocurrido un error', error, 'danger')
            })
        }
      })
    },
    getEditNormativa(data, dataNormativa) {
      this.formTypeNormativa = 'edit'
      this.normativaSel = data
      this.dataEditNormativa = dataNormativa
      this.isToggleSidebarNormativa = true
    },
    listarRegistros() {
      this.isBusy = true
      store
        .dispatch('portal/TRAMITE_ORIENTACION_FIND_ALL', {
          tipo: 'grilla',
          limit: this.perPage,
          query: this.query,
          page: this.page,
          sortBy: 'orden%7CASC',
        })
        .then(response => {
          this.items = response.items
          this.totalRows = response.totalRows
          this.totalItems = response.totalItems
          this.totalPage = response.totalPage
          this.from = this.perPage * (this.page - 1) + (this.totalRows ? 1 : 0)
          this.to = this.perPage * (this.page - 1) + this.totalRows
          this.of = this.totalItems
          this.isBusy = false
        })
        .catch(error => {
          this.$bvToast.toast(error, {
            title: 'Ha ocurrido un error',
            variant: 'danger',
            solid: true,
          })
          this.isBusy = false
        })
    },
    openForm(type) {
      this.formType = type
      this.isAddNewSidebarActive = true
    },
    toggleDetails() {

    },
    getEdit(data) {
      this.formType = 'edit'
      this.isAddNewSidebarActive = true
      this.dataEdit = data.item
    },
    getDelete(data) {
      this.$swal({
        title: 'Está seguro?',
        text: 'Va eliminar un registro!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store
            .dispatch('portal/TRAMITE_ORIENTACION_DELETE', {
              id: data.item.idTramiteOrientacion,
            })
            .then(response => {
              this.listarRegistros()
              this.$bvToast.toast('Ha Eliminado correctamente el registro.', {
                title: 'Operación Exitosa',
                variant: 'success',
                solid: true,
              })
              return response
            })
            .catch(error => {
              this.$bvToast.toast(error, {
                title: 'Ha ocurrido un error',
                variant: 'danger',
                solid: true,
              })
            })
        }
      })
    },
    refetchData(response) {
      let message = 'El proceso se ha ejecutado satisfactoriamente.'
      if (response.message) {
        message = response.message
      }
      this.$bvToast.toast(message, {
        title: 'Operación Extitosa',
        variant: 'success',
        solid: true,
      })
      this.listarRegistros()
    },
    showError(error) {
      let errorMessage = 'Intentelo en otro momento.'
      if (error.response) {
        errorMessage = error.response.data.message
      }
      this.$bvToast.toast(errorMessage, {
        title: 'Ha ocurrido un error',
        variant: 'danger',
        solid: true,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.invoice-filter-select {
  min-width: 190px;
  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }
  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>
<style>
.b-table-details{
  background: darkslateblue !important;
}
.bkwhite {
  background: white !important;
}
.w100{
  width: 100px !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
